import React from 'react';

const DEFAULT_FAILURE_MESSAGE =
  'Your payment could not be processed. Please check your payment details or try another payment method.';

interface FailureReasonBoxProps {
  message?: string | null;
  className?: string;
}

export const FailureReasonBox: React.FC<FailureReasonBoxProps> = ({
  message,
  className = '',
}) => {
  const displayMessage = message || DEFAULT_FAILURE_MESSAGE;

  return (
    <div
      className={`w-full rounded-[14px] bg-[#FFF1F2] border border-[#FECDD3] p-4 flex items-start gap-3 ${className}`}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 24 24'
        fill='none'
        stroke='#E11D48'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='flex-shrink-0 mt-0.5'
      >
        <circle cx='12' cy='12' r='10' />
        <line x1='12' y1='8' x2='12' y2='12' />
        <line x1='12' y1='16' x2='12.01' y2='16' />
      </svg>
      <div className='flex flex-col gap-1'>
        <span className='text-xs font-bold uppercase tracking-wider text-[#9F1239]'>
          Failure reason
        </span>
        <span className='text-sm text-[#881337] leading-snug'>{displayMessage}</span>
      </div>
    </div>
  );
};
